/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import ReactDatePicker from 'react-datepicker';
import React, { Component } from 'react';
import moment from 'moment';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import { Form } from 'semantic-ui-react';
import 'react-datepicker/dist/react-datepicker.css';

class DatePicker extends Component {
    handleChange = value => {
        const { onChange, name } = this.props;

        if (isObject(value)) {
            value = value.utc().format();
        }

        if (onChange) onChange(null, { name, value });
    };

    render() {
        let { value, placeholder, ...rest } = this.props;

        if (isString(value)) value = moment(value);

        return (
            <Form.Field>
                <style>
                    {`
                    .react-datepicker-wrapper, .react-datepicker__input-container {
                        width: 100%;
                    }
                    `}
                </style>
                <If condition={this.props.label}>
                    <label>{this.props.label}</label>
                </If>
                <ReactDatePicker
                    dateFormat="DD/MM/YYYY"
                    {...rest}
                    placeholderText={placeholder}
                    style={{ width: '100%' }}
                    onChange={this.handleChange}
                    selected={value}
                    locale={navigator.language || navigator.userLanguage || 'en'}
                />
            </Form.Field>
        );
    }
}

export default DatePicker;
